import React from 'react'

const TourPackage = () => {
    return (
        <div>Tour Package</div>
    )
}

export default TourPackage